import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { MdPhone, MdEmail, MdLocationOn } from 'react-icons/md';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    budget: '',
    topic: '',
    synopsis: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  const contactInfo = [
    {
      icon: <MdPhone />,
      title: 'Phone',
      content: '+91 (123) 456-7890',
      link: 'tel:+911234567890'
    },
    {
      icon: <MdEmail />,
      title: 'Email',
      content: 'support@virvessoftware.com',
      link: 'mailto:support@virvessoftware.com'
    },
    {
      icon: <MdLocationOn />,
      title: 'Location',
      content: 'Cinnabar Hills, Embassy Golf Links Business Park, Challaghatta, Bengaluru, Karnataka 560071',
      link: 'https://maps.google.com/?q=Bangalore,India'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <Box className="contact-form-section">
      <Container maxWidth="lg">
        <Box className="contact-form-wrapper">
          {/* Left Side - Contact Form */}
          <Box className="contact-form-container">
            <Typography variant="h3" className="contact-title">
              Contact Us
            </Typography>
            <Typography variant="body1" className="contact-subtitle">
              If you have full project details, consider completing a Request For Quote form instead.
            </Typography>
            <form onSubmit={handleSubmit}>
              <div className="form-fields-grid">
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Hi, I am</Typography>
                  <TextField
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="What people call you"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Reach me via Email</Typography>
                  <TextField
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="Email"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Select your Budget range</Typography>
                  <TextField
                    name="budget"
                    select
                    value={formData.budget}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Select a range"
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="">Select a range</option>
                    <option value="0-5k">$0 - $5,000</option>
                    <option value="5k-10k">$5,000 - $10,000</option>
                    <option value="10k-25k">$10,000 - $25,000</option>
                    <option value="25k+">$25,000+</option>
                  </TextField>
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">I want to talk about</Typography>
                  <TextField
                    name="topic"
                    select
                    value={formData.topic}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Select an Option"
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="">Select an Option</option>
                    <option value="web">Web Development</option>
                    <option value="mobile">Mobile Development</option>
                    <option value="cloud">Cloud Solutions</option>
                    <option value="ai">AI & Machine Learning</option>
                    <option value="design">UI/UX Design</option>
                    <option value="other">Other</option>
                  </TextField>
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Or you can call me at</Typography>
                  <TextField
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Phone number"
                    type="tel"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Attachment</Typography>
                  <Box className="upload-box">
                    Choose a file
                  </Box>
                </Box>
                <Box className="form-field full-width">
                  <Typography variant="body2" className="field-label">Project Synopsis</Typography>
                  <TextField
                    name="synopsis"
                    value={formData.synopsis}
                    onChange={handleChange}
                    required
                    multiline
                    rows={3}
                    variant="outlined"
                    placeholder="Enter Your Synopsis"
                  />
                </Box>
                {/* <Box className="form-field full-width">
                  <ReCAPTCHA
                    sitekey="YOUR_RECAPTCHA_SITE_KEY"
                    onChange={() => {}}
                  />
                </Box> */}
              </div>
              <Box className="privacy-notice">
                By submitting this form, I consent that Virves can process my data for the purpose of making me an offer for their services. Read our <a href="/privacy-policy" className="privacy-link">Privacy Policy</a>.
              </Box>
              <Button
                type="submit"
                variant="contained"
                className="submit-button"
              >
                Submit
              </Button>
            </form>
          </Box>

          {/* Right Side - Quick Links */}
          <Box className="quick-links-container">
            <Typography variant="h4" className="quick-links-title">
              Quick Links
            </Typography>
            <Typography variant="body1" className="quick-links-subtitle">
              Get in touch with us for any questions about our services.
            </Typography>
            {contactInfo.map((info, index) => (
              <motion.div
                key={info.title}
                className="quick-links-group"
                variants={itemVariants}
              >
                <Typography variant="h6" className="group-title">
                  {info.icon}
                  {info.title}
                </Typography>
                <Typography variant="body1" className="group-desc">
                  <a href={info.link}>{info.content}</a>
                </Typography>
              </motion.div>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactForm; 